module.exports = __webpack_public_path__ + "img/bulk-truck-icon.cfb3151d.svg";